import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { NativeProvider } from "./NativeContext";
import { AuthProvider } from "./AuthContext";
import { KioskProvider } from "./KioskContext";
// import reportWebVitals from './reportWebVitals';

const updateHeight = () => {
    const vh = window.innerHeight;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
};
updateHeight();
window.addEventListener("resize", updateHeight);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    // <React.StrictMode>
    <NativeProvider>
        <AuthProvider>
            <KioskProvider>
                <App />
            </KioskProvider>
        </AuthProvider>
    </NativeProvider>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
